import salesTableComponentUrl from './salesTableComponent.html';

export default {
  bindings: {
    data: '<',
    columns: '<',
    type: '<',
    canDataColumnBeVisible: '<',
    filtersOpened: '<',
    schema: '<',
    toggleCollapse: '=',
    collapsedGroups: '=',
    getDataForExport: '=',
    onSalesUpdate: '&',
  },
  templateUrl: salesTableComponentUrl,
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './salesTableComponentCtrl')).default,
};
